import React from 'react';
import { privacyHtml } from '../static/privacy';

const Privacy = () => {
  return (
    <div style={{ width: "100%", overflowX: "hidden" }} dangerouslySetInnerHTML={{ __html: privacyHtml(`${process.env.PUBLIC_URL}/images/mini-logo.png`) }}></div>
  )
}

export default Privacy;